$(document).ready(function () {
  $('.flash').click(function(event){
    $(this).hide();
  });

  $('.dc-flash').click(function(event){
    $(this).hide();
  });
});
